export default __webpack_public_path__ + "ff74aaa047f5935e5b8b1b4f1763c9cd.jpg";